import { createSlice } from "@reduxjs/toolkit";

export const poDataSlice = createSlice({
  name: "poData",
  initialState: {
    poData: {},
  },
  reducers: {
    updatePoData: (state, action) => {
      state.poData = action.payload;
    },
  },
});
export const { updatePoData } = poDataSlice.actions;
export default poDataSlice.reducer;
